export default __webpack_public_path__ + "static/bannerProcess-e1c31fbb02bb9654aa241bf123a79e3d.png";